/**
 * "Start with" chips above the composer for the member's first reply. The server sends
 * the texts with each live-tail load of a conversation. A click puts a text into the
 * composer. It never sends. The strip hides while the composer holds text, and for good
 * once the member sends in that conversation.
 */
(function () {
  'use strict';

  // Thread id -> {lang, texts}, from the last live-tail load of it.
  var openers = {};
  // Thread ids the member sent in on this page.
  var sent = {};

  function root() {
    return document.getElementById('reply_openers');
  }

  function composer() {
    return document.getElementById('message');
  }

  function composerThreadId() {
    var input = document.getElementById('send_thread_id');
    return input && input.value ? String(input.value) : null;
  }

  function normalize(data) {
    if (!data || !Array.isArray(data.texts)) return null;
    var texts = data.texts.filter(function (text) { return typeof text === 'string' && text !== ''; });
    return texts.length ? { lang: typeof data.lang === 'string' ? data.lang : '', texts: texts } : null;
  }

  function fill(input, text) {
    // The composition tracker reads the source from beforeinput. A chip is a replacement, not a paste.
    if (typeof InputEvent === 'function') {
      input.dispatchEvent(new InputEvent('beforeinput', { bubbles: true, inputType: 'insertReplacementText' }));
    }
    input.value = text;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
    input.setSelectionRange(text.length, text.length);
  }

  function renderChips(strip, threadId, data) {
    var chips = strip.querySelector('[data-reply-openers-chips]');
    if (!chips) return;
    chips.textContent = '';
    data.texts.forEach(function (text) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'flex-none max-w-[280px] truncate h-11 [@media(pointer:fine)]:h-9 px-3.5 rounded-full border '
        // theme() value: dark-overrides.scss forces plain bg-sky-50 with !important.
        + 'border-[theme(colors.sky.400)] bg-[theme(colors.sky.50)] text-sm text-gray-900 '
        + 'hover:bg-[theme(colors.sky.100)] dark:border-[hsl(220,12%,20%)] dark:bg-sky-950 '
        + 'dark:text-[hsl(215,14%,93%)] dark:hover:bg-sky-900 focus:outline-none focus-visible:ring-2 '
        + 'focus-visible:ring-brand transition-colors';
      chip.dir = 'auto';
      chip.title = text;
      chip.setAttribute('aria-describedby', 'reply_openers_hint');
      if (data.lang) chip.lang = data.lang.replace('_', '-');
      chip.textContent = text;
      chip.addEventListener('click', function () {
        var input = composer();
        if (input && composerThreadId() === threadId) fill(input, text);
      });
      chips.appendChild(chip);
    });
  }

  /** Show the strip for the conversation the composer writes to, or hide it. */
  function sync() {
    var strip = root();
    if (!strip) return;
    var threadId = composerThreadId();
    var input = composer();
    var data = threadId && !sent[threadId] ? openers[threadId] : null;
    var show = !!data && !!input && input.value.trim() === '';
    if (!show) {
      strip.hidden = true;
      return;
    }
    if (strip.getAttribute('data-thread-id') !== threadId) {
      strip.setAttribute('data-thread-id', threadId);
      renderChips(strip, threadId, data);
    }
    strip.hidden = false;
  }

  /** Called with each live-tail load of a conversation. */
  function applyLoad(threadId, data) {
    threadId = String(threadId);
    var next = normalize(data);
    if (next) {
      openers[threadId] = next;
    } else {
      delete openers[threadId];
    }
    var strip = root();
    if (strip && strip.getAttribute('data-thread-id') === threadId) strip.removeAttribute('data-thread-id');
    sync();
  }

  /** The member sent in this conversation, so its strip does not come back. */
  function markSent(threadId) {
    if (!threadId) return;
    sent[String(threadId)] = true;
    sync();
  }

  function init() {
    var strip = root();
    var input = composer();
    if (!strip || !input) return;
    input.addEventListener('input', sync);
    var threadId = composerThreadId();
    if (threadId) {
      var data = null;
      try {
        data = JSON.parse(strip.getAttribute('data-reply-openers') || 'null');
      } catch (e) {
        data = null;
      }
      applyLoad(threadId, data);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PmReplyOpeners = {
    applyLoad: applyLoad,
    markSent: markSent,
    sync: sync
  };
})();
